export default "__VITE_ASSET__C4qc_YWn__"